import { render, staticRenderFns } from "./MarketingMaterials.vue?vue&type=template&id=567ddaa4&scoped=true"
import script from "./MarketingMaterials.vue?vue&type=script&lang=js"
export * from "./MarketingMaterials.vue?vue&type=script&lang=js"
import style0 from "./MarketingMaterials.vue?vue&type=style&index=0&id=567ddaa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ddaa4",
  null
  
)

export default component.exports